import { Navigate, Route } from 'react-router-dom';

import { useAuth } from '@/auth';
import { AgreePage } from '@/pages/agree';
import { AssessmentsPage } from '@/pages/assessments';
import { DiscoverPage } from '@/pages/discover';
import { OrganizePage } from '@/pages/organize';
import { ReportPage } from '@/pages/report';
import { WelcomePage } from '@/pages/welcome-v2';
import { Layout, WithRouteGuard } from '@/shared/components';
import { RoutesEnum } from '@/shared/duck';
import { AssessmentsProvider } from '@/shared/providers';

import { NotFoundPage } from './not-found';

const usePagesRoutes = () => {
  const { isLoggedIn } = useAuth();

  return (
    <>
      <Route path={RoutesEnum.Welcome} element={<WithRouteGuard element={<WelcomePage />} />} />

      <Route element={<Layout />}>
        <Route
          path={RoutesEnum.Root}
          element={
            <WithRouteGuard
              element={
                <Navigate
                  to={isLoggedIn ? RoutesEnum.Discover : RoutesEnum.Welcome}
                  replace
                />
              }
            />
          }
        />

        {isLoggedIn && (
          <>
            <Route path={RoutesEnum.Discover} element={<WithRouteGuard element={<DiscoverPage />} />} />
            <Route path={RoutesEnum.Organizations} element={<WithRouteGuard element={<OrganizePage />} />} />
            <Route
              path={RoutesEnum.Assessments}
              element={
                <WithRouteGuard
                  element={
                    <AssessmentsProvider>
                      <AssessmentsPage />
                    </AssessmentsProvider>
                  }
                />}
            />
            <Route path={RoutesEnum.Agree} element={<WithRouteGuard element={<AgreePage />} />} />
            <Route path={RoutesEnum.Report} element={<WithRouteGuard element={<ReportPage />} />} />
          </>
        )}

        <Route path='*' element={<NotFoundPage />} />
      </Route>
    </>
  );
};

export default usePagesRoutes;